<template>
  <form
    class="flex flex-col gap-4"
  >
    <slot />
  </form>
</template>
